import React from "react";
import SectionCard from "../SectionCard/SectionCard";
import SideImage from "../../assets/images/pessoas-conversando-apertando-maos.svg";

function ExercaSeusDireitos() {
  const subtext1 = (
    <p>
      <b>Levamos a sério a proteção </b> de seus dados e, por isso, temos um
      Portal de Privacidade dedicado a esse assunto, para que você conheça mais
      seus direitos e os exerça.
      <br />
    </p>
  );
  const subtext2 = (
    <p>
      Devido à complexidade de nosso ambiente tecnológico e para dar a você
      respostas adequadas e corretas, precisamos de até 15 dias para responder a
      solicitações de acesso aos seus dados pessoais.
      <b> Fique tranquilo</b>: que seu pedido será devidamente analisado e respondido 
      dentro dos prazos legais aplicáveis.
      <br />
    </p>
  );
  const subtext3 = (
    <p>
      <b>Lembre-se:</b> para garantir sua identidade e que seu pedido é
      legitimo, nos próximos formulários vamos coletar seus dados pessoais e
      documentos que nos ajudam em nosso processo de autenticação. Esses dados
      ficarão armazenados em nossas bases de dados para possíveis demandas
      legais e regulatórias, comprovando que seu pedido foi feito e atendido.
      Nós não utilizaremos seus dados para outros fins.
      <br />
    </p>
  );
  return (
    <SectionCard
      id="Exercaseusdireitos"
      title="Exerça Seus Direitos"
      subtext1={subtext1}
      subtext2={subtext2}
      subtext3={subtext3}
      image={SideImage}
    />
  );
}

export default ExercaSeusDireitos;
